import React from "react";
import { UserResponse } from "../../../../generated/user-api";
import VideoSettings from "./Components/VideoSettings/VideoSettings";

interface Props {
  user: UserResponse;
}

const Settings = (props: Props) => {
  const { user } = props;

  return (
    <>
      <VideoSettings userId={user.id} disableUpload />
    </>
  );
};

export default Settings;
